var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhramacySavedBills(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_11769",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_11769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 26.8333L6.10002 20.5333C5.80835 20.3195 5.57988 20.0472 5.4146 19.7167C5.24933 19.3861 5.16669 19.0361 5.16669 18.6667V4.66668C5.16669 4.02501 5.39516 3.4757 5.8521 3.01876C6.30905 2.56182 6.85835 2.33334 7.50002 2.33334H21.5C22.1417 2.33334 22.691 2.56182 23.1479 3.01876C23.6049 3.4757 23.8334 4.02501 23.8334 4.66668V18.6667C23.8334 19.0361 23.7507 19.3861 23.5854 19.7167C23.4202 20.0472 23.1917 20.3195 22.9 20.5333L14.5 26.8333ZM14.5 23.9167L21.5 18.6667V4.66668H7.50002V18.6667L14.5 23.9167ZM13.275 17.5L19.8667 10.9083L18.2334 9.21668L13.275 14.175L10.825 11.725L9.13335 13.3583L13.275 17.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhramacySavedBills);
export default __webpack_public_path__ + "static/media/PhramacySavedBills.cd476829a8dcc801ef538b528a32e46a.svg";
export { ForwardRef as ReactComponent };